"use client";

import Translation from "@workspace/casino_pages/legacyLayer/client/components/Translation";
import classNames from "@workspace/casino_pages/legacyLayer/external/classNames";
import Button from "@workspace/casino_pages/legacyLayer/legacyUi/Button";
import Img from "@workspace/casino_pages/legacyLayer/legacyUi/Img";
import getCdnImg from "@workspace/casino_pages/legacyLayer/shared/cdn/getCdnImg";
import Content from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/Content";
import handleMarkAsRead from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/graphql/handleMarkAsRead";
import useHandleNotificationClick from "@/server/components/NotificationWorker/NotificationWorkerHandler/showNotification/NotificationView/useHandleNotificationClick";

const LoyaltyNotification: FC<NotificationViewProps> = ({
  notification,
  onClose,
  context,
}) => {
  const isButtonNeeded = notification.type === "loyaltyMilestone";
  const isSportsbet = context.site === "sportsbet";

  const handleClose = () => {
    handleMarkAsRead(notification.data);
    onClose();
  };

  const { handleNotificationClick } = useHandleNotificationClick({
    notification: notification.data,
    onClose: handleClose,
    context,
  });

  return (
    <Content onClose={onClose}>
      <div
        className="grid cursor-pointer gap-2 pt-6"
        onClick={handleNotificationClick}
      >
        <div
          className={classNames(
            "relative m-auto flex h-12 w-12 flex-row items-center justify-center rounded-lg bg-primary bg-top bg-no-repeat",
            "rounded-lg border-solid before:absolute before:left-0 before:top-0 before:h-full before:w-full before:border-2 before:border-white before:bg-transparent before:opacity-40",
            notification.type === "loyaltyMilestone" && "bg-discovery",
            isSportsbet && "bg-foreground",
          )}
          style={{
            backgroundImage: `url('${getCdnImg(
              "loyalty/loyalty-icon-bg-pattern.svg",
            )}')`,
          }}
        >
          <Img height={37} width={37} src={notification.data.icon} alt={""} />
        </div>
        <h4 className="text-lg/6 font-medium text-black">
          {notification.data.title}
        </h4>
        <p
          className="text-sm/6 text-muted-foreground"
          dangerouslySetInnerHTML={{ __html: notification.data.body }}
        />
      </div>
      {isButtonNeeded && (
        <div className="flex flex-row items-center justify-center">
          <Button variant="primary" fullWidth onClick={handleNotificationClick}>
            <Translation
              id="notifications.loyalty.claim_now"
              translations={context.translations}
            />
          </Button>
        </div>
      )}
    </Content>
  );
};
export default LoyaltyNotification;
